__turbopack_context__.v({
  "Arrow": "NotificationsMenu-module-scss-module__R7GJGG__Arrow",
  "ArrowFill": "NotificationsMenu-module-scss-module__R7GJGG__ArrowFill",
  "ArrowInnerStroke": "NotificationsMenu-module-scss-module__R7GJGG__ArrowInnerStroke",
  "ArrowOuterStroke": "NotificationsMenu-module-scss-module__R7GJGG__ArrowOuterStroke",
  "Avatar": "NotificationsMenu-module-scss-module__R7GJGG__Avatar",
  "Button": "NotificationsMenu-module-scss-module__R7GJGG__Button",
  "Fallback": "NotificationsMenu-module-scss-module__R7GJGG__Fallback",
  "Image": "NotificationsMenu-module-scss-module__R7GJGG__Image",
  "Item": "NotificationsMenu-module-scss-module__R7GJGG__Item",
  "NotificationsLabel": "NotificationsMenu-module-scss-module__R7GJGG__NotificationsLabel",
  "Popup": "NotificationsMenu-module-scss-module__R7GJGG__Popup",
  "Positioner": "NotificationsMenu-module-scss-module__R7GJGG__Positioner",
  "Separator": "NotificationsMenu-module-scss-module__R7GJGG__Separator",
  "SeparatorWrapper": "NotificationsMenu-module-scss-module__R7GJGG__SeparatorWrapper",
  "itemSub": "NotificationsMenu-module-scss-module__R7GJGG__itemSub",
  "link": "NotificationsMenu-module-scss-module__R7GJGG__link",
  "mobile": "NotificationsMenu-module-scss-module__R7GJGG__mobile",
  "notificationsCount": "NotificationsMenu-module-scss-module__R7GJGG__notificationsCount",
});
